import React from "react";
import { RouteComponentProps } from "react-router-dom";
import "./Settings.css";
import "../../App.css";
import HashLoader from "react-spinners/HashLoader";
import SecButton from "../../components/SecButton";
import { fetchRetry } from "../../functions/request";
import SwitchSetting from "../../components/SwitchSetting";
import Title from "../../components/Title";

type Props = {};
type ComposedProps = Props &
  RouteComponentProps<{
    clubId: string;
    branchId: string;
  }>;

export default class Settings extends React.Component<
  ComposedProps,
  {
    clubId: string;
    branchId: string;
    requestNeeded: boolean;
    branch: any;
    branchLoaded: boolean;
    change: boolean;
    updateLoading: boolean;
  }
> {
  constructor(props: ComposedProps) {
    super(props);
    this.state = {
      clubId: this.props.match.params.clubId,
      branchId: this.props.match.params.branchId,
      requestNeeded: false,
      branch: {},
      branchLoaded: false,
      change: false,
      updateLoading: false,
    };
  }

  componentDidMount = () => {
    this.requestBranch();
  };

  requestBranch = () => {
    fetchRetry(
      "getBranchFromId",
      {
        clubId: this.state.clubId,
        branchId: this.state.branchId,
      },
      1,
      5
    )
      .then(this.handleBranch)
      .catch(this.handleError);
  };

  handleBranch = ({ data }: any) => {
    this.setState({ branchLoaded: true });
    if (data.success) {
      const branch = data.data;
      this.setState(
        {
          branch: branch,
          requestNeeded: branch.settings.requestNeeded,
        },
        this.checkChange
      );
    }
  };

  handleError = (err: any) => {
    console.error(err);
  };

  handleRequestNeededChange = () => {
    this.setState(
      { requestNeeded: !this.state.requestNeeded },
      this.checkChange
    );
  };

  checkChange = () => {
    this.setState({
      change:
        this.state.requestNeeded !== this.state.branch.settings.requestNeeded,
    });
  };

  updateBranch = () => {
    this.setState({ updateLoading: true });
    fetchRetry(
      "updateBranch",
      {
        clubId: this.state.clubId,
        branchId: this.state.branchId,
        settings: {
          requestNeeded: this.state.requestNeeded,
        },
      },
      1,
      5
    )
      .then(this.handleSuccessUpdate)
      .catch(this.handleError);
  };

  handleSuccessUpdate = ({ data }: any) => {
    this.setState({ updateLoading: false });
    this.requestBranch();
  };

  render() {
    if (!this.state.branchLoaded) {
      return (
        <>
          <div className="loading-container">
            <HashLoader color={"#c31924"} size={100} loading={true} />
          </div>
        </>
      );
    }
    return (
      <>
        <div className="subscreen-main-container">
          <div className="subscreen-box-container">
            <Title title="Einstellungen" />
            <SwitchSetting
              value={this.state.requestNeeded}
              onChange={this.handleRequestNeededChange}
              name="Mitglieder mussen verifiziert werden"
            />
            <SecButton
              change={this.state.change}
              color="green"
              loading={this.state.updateLoading}
              onClick={this.updateBranch}
              title="Speichern"
            />
          </div>
        </div>
      </>
    );
  }
}
